import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { ParkingPass as ParkingPassModel } from 'models/parking-passes';

import { vendgateEarlyMessage } from 'lib/common/messages';
import { FormattedMessage } from 'react-intl';

class GateButton extends React.Component {
  constructor(props) {
    super(props);

    this.openGate = this.openGate.bind(this);
    this.openGateModal = this.openGateModal.bind(this);
    this.dismissModal = this.dismissModal.bind(this);
  }

  openGate() {
    const { parkingPass, openGate, addMessage } = this.props;
    if (parkingPass.gateAvailable) {
      openGate({ parkingPass });
    } else {
      addMessage(vendgateEarlyMessage);
    }
  }

  openGateModal(e) {
    const { addMessage, parkingPass } = this.props;
    e.preventDefault();
    e.stopPropagation();

    if (parkingPass.gateAvailable) {
      this.props.changeModalState({
        displayModal: true,
        body: 'gateButton',
        footer: 'generalFooter',
        bodyProps: {
          openGate: this.openGate,
          dismissModal: this.dismissModal,
        },
      });
    } else {
      addMessage(vendgateEarlyMessage);
    }
  }

  dismissModal(e) {
    e.preventDefault();
    e.stopPropagation();

    this.props.changeModalState({
      displayModal: false,
    });
  }

  render() {
    const { parkingPass, className } = this.props;
    const buttonClasses = cx({
      'gate-button': true,
      'btn-block': true,
      'btn-primary': true,
      'btn-text-size-2': true,
      'text-center': true,
      'visible-lte-sm': true,
      'clickable': parkingPass.gateAvailable,
      'btn-disabled': !parkingPass.gateAvailable,
    });

    return (
      <div>
        <div className={`${buttonClasses} ${className}`} onClick={this.openGateModal} >
          <FormattedMessage
            id="parking-pass.open-gate"
            defaultMessage="OPEN GATE"
          />
        </div>
        <div className="hidden-lte-sm validation-box text-color-dark-slate">
          <FormattedMessage
            id="parking-pass.gate-desktop-notice"
            defaultMessage="You can only open parking gates from a mobile device. Please open this pass on your phone when arriving at your destination."
          />
        </div>
      </div>
    );
  }
}

GateButton.propTypes = {
  parkingPass: PropTypes.instanceOf(ParkingPassModel).isRequired,
  openGate: PropTypes.func.isRequired,
  changeModalState: PropTypes.func.isRequired,
  addMessage: PropTypes.func.isRequired,
  className: PropTypes.string,
};

GateButton.defaultProps = {
  className: '',
};

export default GateButton;
